import React, { useState, useEffect, useContext } from 'react';
import { Table, Button, Drawer, Form, Input, message } from 'antd';
import axios from 'axios';
import { LoginContext } from '../../context/loginContext';

const CMarcas = () => {
  const [marcas, setMarcas] = useState([]);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [editMarca, setEditMarca] = useState(null);
  const [form] = Form.useForm();
  const { user } = useContext(LoginContext);

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');

  useEffect(() => {
    fetchMarcas();
  }, []);

  const fetchMarcas = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/marcas`, {
        headers: {
          Authorization: `Bearer ${user.token}`,
        },
      });
      setMarcas(response.data);
    } catch (error) {
      console.error('Error al obtener marcas:', error);
    }
  };

  const openDrawer = (marca = null) => {
    setEditMarca(marca);
    setDrawerVisible(true);
    if (marca) {
      form.setFieldsValue(marca);
    } else {
      form.resetFields();
    }
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const handleSaveMarca = async (values) => {
    try {
      const headers = {
        Authorization: `Bearer ${user.token}`,
      };

      if (editMarca) {
        await axios.put(`${process.env.REACT_APP_API_URL}/marcas/${editMarca._id}`, values, { headers });
        message.success('Marca actualizada correctamente');
      } else {
        await axios.post(`${process.env.REACT_APP_API_URL}/marcas`, values, { headers });
        message.success('Marca creada correctamente');
      }

      fetchMarcas();
      closeDrawer();
    } catch (error) {
      message.error('Error al guardar marca');
      console.error('Error al guardar marca:', error);
    }
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button type="primary" onClick={() => handleSearch(selectedKeys, confirm, dataIndex)} size="small">
            Buscar
          </Button>
          <Button onClick={() => handleReset(clearFilters)} size="small">
            Resetear
          </Button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => <span style={{ color: filtered ? '#1890ff' : undefined }}>🔍</span>,
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    render: (text) =>
      searchedColumn === dataIndex ? (
        <span style={{ backgroundColor: '#ffc069', padding: '0 5px' }}>{text}</span>
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nombre de Marca',
      dataIndex: 'nombre',
      key: 'nombre',
      ...getColumnSearchProps('nombre'),
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (text, record) => (
        <Button type="link" onClick={() => openDrawer(record)}>
          Editar
        </Button>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" onClick={() => openDrawer()} style={{ marginBottom: 16 }}>
        Agregar Marca
      </Button>

      <Table columns={columns} dataSource={marcas} rowKey="_id" />

      <Drawer
        title={editMarca ? 'Editar Marca' : 'Agregar Marca'}
        width={400}
        onClose={closeDrawer}
        visible={drawerVisible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form form={form} layout="vertical" onFinish={handleSaveMarca}>
          <Form.Item
            name="nombre"
            label="Nombre de Marca"
            rules={[{ required: true, message: 'Por favor ingresa un nombre de marca' }]}
          >
            <Input placeholder="Nombre de Marca" />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" block>
              {editMarca ? 'Actualizar Marca' : 'Crear Marca'}
            </Button>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default CMarcas;